
import './base.css';

function Services() {
    return (
        <section id="services" className="s-services">
            <div
                className="row section-header has-bottom-sep"
                data-aos="fade-up"
            >
                <div className="col-full">
                    <h3 className="subhead">O que eu faço</h3>
                    <h1 className="display-2">
                        Arquitetura, engenharia e liderança tecnológica
                        para construir sistemas escaláveis, seguros e
                        preparados para evoluir.
                    </h1>
                </div>
            </div>

            <div className="row services-list block-1-2 block-tab-full">

                {/* Arquitetura de Software */}
                <div
                    className="col-block service-item"
                    data-aos="fade-up"
                >
                    <div className="service-icon">
                        <i className="icon-cmd"></i>
                    </div>
                    <div className="service-text">
                        <h3 className="h2">
                            Arquitetura de Software
                        </h3>
                        <p>
                            Atuo na definição e evolução de arquiteturas
                            corporativas, com foco em escalabilidade,
                            manutenção e eficiência. Tenho experiência
                            na modernização de sistemas legados,
                            decomposição de aplicações monolíticas em
                            microsserviços, arquitetura de microfrontends
                            e modelagem de soluções utilizando C4 Model
                            e IcePanel. Também desenvolvo padrões e
                            templates corporativos para orientar equipes
                            de engenharia e promover consistência
                            entre projetos.
                        </p>
                    </div>
                </div>

                {/* Cloud e DevOps */}
                <div
                    className="col-block service-item"
                    data-aos="fade-up"
                >
                    <div className="service-icon">
                        <i className="icon-cube"></i>
                    </div>
                    <div className="service-text">
                        <h3 className="h2">
                            Cloud, DevOps e SRE
                        </h3>
                        <p>
                            Experiência na arquitetura e implantação
                            de plataformas em Google Cloud (GCP) e AWS,
                            com infraestrutura como código utilizando
                            Terraform. Trabalho com Kubernetes, GKE,
                            Docker, Rancher, pipelines CI/CD e
                            automação de deploys. Atuo na padronização
                            de ambientes, organização de infraestrutura
                            multicloud e multicluster, além de práticas
                            de confiabilidade, observabilidade,
                            disponibilidade e eficiência operacional.
                        </p>
                    </div>
                </div>

                {/* Desenvolvimento Backend */}
                <div
                    className="col-block service-item"
                    data-aos="fade-up"
                >
                    <div className="service-icon">
                        <i className="icon-factory"></i>
                    </div>
                    <div className="service-text">
                        <h3 className="h2">
                            Engenharia Backend
                        </h3>
                        <p>
                            Desenvolvimento de sistemas e APIs com
                            Python, Django e FastAPI, além de
                            experiência com Rust, C e C++.
                            Atuo na construção de serviços backend,
                            autenticação, autorização, integração entre
                            sistemas e modelagem de aplicações
                            distribuídas. Tenho experiência na criação
                            de templates corporativos, aplicação de
                            padrões arquiteturais e desenvolvimento
                            de soluções voltadas à evolução de
                            sistemas críticos e legados.
                        </p>
                    </div>
                </div>

                {/* Banco de Dados e Big Data */}
                <div
                    className="col-block service-item"
                    data-aos="fade-up"
                >
                    <div className="service-icon">
                        <i className="icon-earth"></i>
                    </div>
                    <div className="service-text">
                        <h3 className="h2">
                            Dados e Persistência
                        </h3>
                        <p>
                            Arquitetura e modelagem de dados relacionais
                            e não relacionais, com experiência em
                            PostgreSQL, MariaDB, Microsoft SQL Server,
                            MongoDB, Redis, Elasticsearch, OpenSearch
                            e Solr. Desenvolvo consultas SQL avançadas,
                            integrações entre diferentes fontes de
                            dados, processos de sincronização e
                            estruturas de apoio a relatórios e
                            indicadores de negócio. Também possuo
                            experiência com BigQuery e Azure Synapse
                            Analytics.
                        </p>
                    </div>
                </div>

                {/* Integração e Automação */}
                <div
                    className="col-block service-item"
                    data-aos="fade-up"
                >
                    <div className="service-icon">
                        <i className="icon-group"></i>
                    </div>
                    <div className="service-text">
                        <h3 className="h2">
                            Integração e Automação
                        </h3>
                        <p>
                            Desenvolvimento de soluções de integração
                            utilizando Node-RED, Python, JavaScript,
                            Rust e Shell Script. Experiência na
                            construção de gateways de APIs, fluxos
                            automatizados de captura e transformação
                            de dados, sincronização entre plataformas,
                            processamento de eventos e mensageria
                            MQTT. Também desenvolvo rotinas de
                            automação operacional, monitoramento
                            e pipelines para aumentar a eficiência
                            e a confiabilidade dos serviços.
                        </p>
                    </div>
                </div>

                {/* IoT e Eletrônica */}
                <div
                    className="col-block service-item"
                    data-aos="fade-up"
                >
                    <div className="service-icon">
                        <i className="icon-lego-block"></i>
                    </div>
                    <div className="service-text">
                        <h3 className="h2">
                            IoT e Sistemas Embarcados
                        </h3>
                        <p>
                            Experiência no desenvolvimento de soluções
                            de Internet das Coisas (IoT), integrando
                            hardware, firmware, sensores e plataformas
                            de monitoramento. Desenvolvo firmwares
                            utilizando C, C++ e Python para
                            microcontroladores e plataformas como
                            ESP32, ESP8266, ATmega328P e Raspberry Pi.
                            Atuo também na integração de dispositivos
                            via MQTT, redes sem fio e Ethernet, além
                            do desenvolvimento de circuitos eletrônicos
                            com KiCad e EasyEDA.
                        </p>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default Services;
